export default __webpack_public_path__ + "static/media/short.4425e4f4.png";